import { Metamodel } from '../base/model';
import { IAttribute, IModel } from '../base/annotation';
import { Owned } from '../base/named';
import { A365BackendModel } from '../a365.backendmodel';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { Credential } from '../credential/credential';

@Metamodel.model({
    name: 'SynapseActivityAuthenticationType',
    referable: true
})
export class SynapseActivityAuthenticationType extends Owned {
    public static readonly MODEL: IModel;
    public static readonly CREDENTIAL: IAttribute;

    public type: A365BackendModel.SynapseActivityAuthType;

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        association: 'CREDENTIAL',
        templatable: false
    })
    public credential?: Credential;
}